var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"width":"100%"}},[_c('div',{staticClass:"asana-embed-container"},[_c('link',{attrs:{"rel":"stylesheet","href":"https://form.asana.com/static/asana-form-embed-style.css"}}),_c('iframe',{staticClass:"asana-embed-iframe",attrs:{"src":_vm.formUrl}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }